import * as React from 'react';
import { CollapsibleDropDown } from '../../../components/CollapsibleDropDown/CollapsibleDropDown';
import { CollapsibleDropDownTitle } from '../../../components/CollapsibleDropDown/CollapsibleDropDownTitle';
import { Link } from '../../../components/Link';
import { IPageDataReducer } from '../../../reducers/pageData';
import { IShipOverviewPageMobileCompany } from '../../../reducers/shipOverview';
import { CompanyRecommendations } from './CompanyRecommendations';

const styles: Record<string, React.CSSProperties> = {
    recommendationChildStyle: {},
    companyLogo: {
        marginRight: 15,
        maxWidth: 80,
    },
    wrapperStyles: {
        height: 57,
    },
};

interface StateProps {
    company: IShipOverviewPageMobileCompany;
    pageData: IPageDataReducer;
}

interface DispatchProps {
    fetchShipPrices: Function;
}

type Props = StateProps & DispatchProps;

export class CompanySection extends React.Component<Props, any> {
    render() {
        const dropdownTitle = (
            <CollapsibleDropDownTitle
                title={this.props.company.title}
                wrapperStyles={styles.wrapperStyles}
            >
                <img
                    src={this.props.company.logo}
                    style={styles.companyLogo}
                    alt={this.props.company.title}
                />
            </CollapsibleDropDownTitle>
        );

        const recommendationSection = this.props.company.ships.map((ship) => {
            return (
                <div key={ship.title}>
                    <Link href={ship.url}>{ship.title}</Link>
                    <p>{ship.teaserDescription}</p>
                </div>
            );
        });

        const lazyRecommendationSection = (
            <CompanyRecommendations
                company={this.props.company}
                currency={this.props.pageData.appConfig.defaultCurrency}
                fetchShipPrices={this.props.fetchShipPrices}
            />
        );

        return (
            <CollapsibleDropDown
                title={dropdownTitle}
                key={this.props.company.title}
                lazyLoadChild={lazyRecommendationSection}
                childStyle={styles.recommendationChildStyle}
            >
                {recommendationSection}
            </CollapsibleDropDown>
        );
    }
}
